// SideBarNav.js

import { useState, useEffect, useMemo } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  getCheckoutClientInfo,
} from "../../services/authService";
import "./SideBarNav.css"; // Refactor this for sidebar styling
import { useUser } from "../../context/UserContext";
import { useConfig } from "../../context/AppConfigContext";
import * as FeatherIcon from "react-feather";
import { PeopleGroupLight } from "../../svgs/PeopleGroupLight";
import { useAuthorizedUser } from "../../context/AuthorizedUserContext";
import { SharpAccountBalance } from "../../svgs/SharpAccountBalance";
import { AppleIntelligenceLine } from "../../svgs/AppleIntelligenceLine";
import { userAuthorized } from "../../utilities/uiUtils";

export default function SideBarNav() {
  const { user } = useUser();
  const { appConfig } = useConfig();
  const [currentRole, setCurrentRole] = useState(user?.role);
  const [currentRoleKey, setCurrentRoleKey] = useState(user?.role_key);
  const user_company =  user?.company_name;
  const user_roles = !user?.roles ? [] : user?.roles;
 const { isAuthorized, isAuthLoading } = useAuthorizedUser();
  console.log("isAuthorized",isAuthorized)
  const user_roles_keys = !appConfig?.user_roles_api
    ? []
    : appConfig?.user_roles_api;
  const [filteredRoles, setFilteredRoles] = useState([]);
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState("");
  const [nav_urls, setNavUrls] = useState({
    dashboard_url: "/dashboard",
    companies_url: "/clients_accounts",
    meeting_preps_url: "/meeting_preps",
    global_contacts_url:"/global_contacts",
    global_accounts_url:"/global_accounts",
    auto_nurture_url: "/auto_nurture",
    ai_assistant_url_v2: "/ai_assistant_2",

  });


  const getRoleKeyByRole = (role) => {
    for (const role_key in user_roles_keys) {
      if (parseInt(user_roles_keys[role_key]) === parseInt(role)) {
        return role_key;
      }
    }
    return "";
  };

  useEffect(() => {
    if (appConfig) {
      const current_role = user?.role;
      setCurrentRole(current_role);
      const user_role_key = getRoleKeyByRole(current_role);
      setCurrentRoleKey(user_role_key);

      const configUserRoles = appConfig.user_roles;
      const updatedFilteredRoles = Object.keys(configUserRoles).filter(
        (role) =>
          user_roles.includes(parseInt(role)) &&
          parseInt(role) !== parseInt(currentRole)
      );
      setFilteredRoles(updatedFilteredRoles);
    }
  }, [appConfig, currentRole, user_roles, currentRoleKey]);

  useEffect(() => {
    if (location.pathname.includes("dashboard")) {
      setActiveMenu("clients_dashboard");
    } else if (location.pathname.startsWith("/clients_accounts") || location.pathname.startsWith("/account_details") || location.pathname.startsWith("/sales_accounts") ) {
      setActiveMenu("clients_accounts");
    } else if (location.pathname.includes("ai_assistant_2")) {
      setActiveMenu("ai_assistant_url_v2");
    } else if (location.pathname.startsWith("/meeting_preps")) {
      setActiveMenu("meeting_preps_url");
    } else if (location.pathname.startsWith("/auto_nurture")) {
      setActiveMenu("auto_nurture_url");
    } else if (location.pathname.startsWith("/global_contacts")) {
      setActiveMenu("global_contacts_url");
    } else if (location.pathname.startsWith("/global_accounts")) {
      setActiveMenu("global_accounts_url");  
    } else { 
      setActiveMenu("");
    }

    const checkoutClientInfo = getCheckoutClientInfo();
    const client_id = checkoutClientInfo?.checkoutClientId || "";
    const client_name = checkoutClientInfo?.checkoutClientName || "";

    const updatedUrls =
      client_id && client_name
        ? {
            dashboard_url: "/dashboard",
            companies_url: `/clients_accounts/${client_id}/${client_name}`,
            meeting_preps_url: "/meeting_preps",
            auto_nurture_url: "/auto_nurture",
            ai_assistant_url_v2: "/ai_assistant_2",
            global_contacts_url:"/global_contacts",
            global_accounts_url:"/global_accounts"
          }
        : {
            dashboard_url: "/dashboard",
            companies_url: "/clients_accounts",
            meeting_preps_url: "/meeting_preps",
            auto_nurture_url: "/auto_nurture",
            ai_assistant_url_v2: "/ai_assistant_2",
            global_contacts_url:"/global_contacts",
            global_accounts_url:"/global_accounts"
          };

    setNavUrls(updatedUrls);
  }, [location.pathname]);
const accountsTo =
  (currentRoleKey === "SALES_DEMO" || currentRoleKey === "ANALYST") ? "/sales_accounts" : nav_urls.companies_url;



  if (!appConfig) return null;


  

console.log("sapnadip",activeMenu)
  

  return (

      <div className="client-layout-main-layout-sidebar">
        <ul className="sidebar-menu">
          {(currentRoleKey === "CLIENT" ||
            currentRoleKey === "CLIENT_EMPLOYEE" ||
            currentRoleKey === "SALES_DEMO" ||
            currentRoleKey === "ANALYST"
          ) && (
            <>
            {/*  */}
          {userAuthorized?.includes(user?.email) &&
              <li className={activeMenu === "ai_assistant_url_v2" ? "active" : ""}>
                <Link to={nav_urls.ai_assistant_url_v2} className="sidebar-container-primary-nav-el">
                  
                  {/* <FeatherIcon.Settings className="sidebar-container-primary-nav-el-icon"/> */}
                  
                  <AppleIntelligenceLine height="1.2rem" width="1.2rem"/>

                   <div className="side_head mt-1">Assistant</div>
                </Link>
              </li>
              }
             <li className={activeMenu === "clients_accounts" ? "active" : ""}>
  <Link to={accountsTo} className="sidebar-container-primary-nav-el">
    <FeatherIcon.Box className="sidebar-container-primary-nav-el-icon" />
    <div className="side_head">Sales Play</div>
  </Link>
</li>

              {isAuthorized &&
              <li className={activeMenu === "global_accounts_url" ? "active" : ""}>
                <Link to={nav_urls.global_accounts_url} className="sidebar-container-primary-nav-el">
                  
                  {/* <FeatherIcon.Settings className="sidebar-container-primary-nav-el-icon"/> */}
                  
                  <SharpAccountBalance height="1.2rem" width="1.2rem"/>

                   <div className="side_head mt-1">Accounts</div>
                </Link>
              </li>
              }

            {user?.company_name=="MARKETS & MARKETS"&&
              <li className={activeMenu === "global_contacts_url" ? "active" : ""}>
                <Link to={nav_urls.global_contacts_url} className="sidebar-container-primary-nav-el">
                  
                  {/* <FeatherIcon.Settings className="sidebar-container-primary-nav-el-icon"/> */}
                  
                  <PeopleGroupLight height="1.2rem" width="1.2rem"/>

                   <div className="side_head mt-1">Contacts</div>
                </Link>
              </li>
              }
             
           


              {(currentRoleKey === "CLIENT" || currentRoleKey === "CLIENT_EMPLOYEE" ) && user_company=="MARKETS & MARKETS" &&
              <li className={activeMenu === "meeting_preps_url" ? "active" : ""}>
                <Link to={nav_urls.meeting_preps_url} className="sidebar-container-primary-nav-el">
                  <FeatherIcon.Calendar className="sidebar-container-primary-nav-el-icon"/> <div className="side_head">Meeting<br />Prep</div>
                </Link>
              </li>
              }

              
              <li className={activeMenu === "auto_nurture_url" ? "active" : ""}>
                <Link to={nav_urls.auto_nurture_url} className="sidebar-container-primary-nav-el">
                  
                  {/* <FeatherIcon.Settings className="sidebar-container-primary-nav-el-icon"/> */}
                  
                  <img src="/img/auto_nurture_icon.png" height="14" width="14" />

                   <div className="side_head mt-1">Auto<br />Nurture</div>
                </Link>
              </li>
              
            </>
          )}
        </ul>

        <div className="sidebar-footer">
          {location.pathname.indexOf("sales_accounts") === -1 && (
            <li className="nav-item">
              <div className="help_block">
                <Link to="/pages/help_account_iq" className="help_link">
                  <img
                    src="/img/icons/icons_qm.png"
                    className="bell_icon"
                    alt="image_help"
                  />
                  <p className="ai_bottom">Help</p>
                </Link>
              </div>
            </li>
          )}
        </div>
      </div>

  );
}
